import { useMenuModal } from 'contexts/MenuModalContext';
import { MinimumAgeBadge } from 'menu/components/MinimumAge';
import { getProductPortions, getSelectedPortion } from 'menu/utils';
import { useEffect, useRef, useState } from 'react';
import { MdArrowBack, MdClose } from 'react-icons/md';
import { AztecProduct } from 'types/models';

interface MenuModalHeaderProps {
  aztecProduct: AztecProduct;
  handleClose: () => void;
}

export const MenuModalHeader: React.FC<MenuModalHeaderProps> = ({
  aztecProduct,
  handleClose,
}) => {
  const { breadcrumbs } = useMenuModal();
  const headerTitleRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);

  const displayRecord =
    aztecProduct?.displayRecords[aztecProduct.displayRecordId];

  const productName = displayRecord?.name || aztecProduct?.displayName;
  const minimumAge = aztecProduct.minimumCustomerAge;

  const selectedPortion = getSelectedPortion(aztecProduct);
  const productPortions = getProductPortions(aztecProduct);

  const showBackButton =
    selectedPortion && (productPortions.length > 1 || breadcrumbs.length > 0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsSticky(!entry.isIntersecting);
      },
      { root: document.querySelector('.scroll-container'), threshold: 0.5 },
    );

    if (headerTitleRef.current) {
      observer.observe(headerTitleRef.current);
    }

    return () => {
      if (headerTitleRef.current) {
        observer.unobserve(headerTitleRef.current);
      }
    };
  }, []);

  return (
    <>
      <div className="menu-modal-header">
        <h2 ref={headerTitleRef}>{productName}</h2>
        {minimumAge ? <MinimumAgeBadge minimumAge={minimumAge} /> : null}
      </div>
      {isSticky && (
        <div className="menu-modal-sticky-header">
          <div className="menu-modal-sticky-header-content">
            <h2>{productName}</h2>
            {minimumAge ? <MinimumAgeBadge minimumAge={minimumAge} /> : null}
          </div>
        </div>
      )}
      <button
        className="icon-button menu-close-icon"
        onClick={handleClose}
        aria-label={showBackButton ? 'Go back' : 'Close'}
      >
        {showBackButton ? <MdArrowBack size={30} /> : <MdClose size={30} />}
      </button>
    </>
  );
};
